import { ViewController, GalleryView, ButtonClickEvent } from "@gaming/srvg-classes-core";

export class SettlementGalleryViewController extends ViewController {
    galleryView: GalleryView;

    constructor( options ) {
        options = options ||{};
        options.view = options.galleryView || null;
        super( options );
        this.galleryView = options.galleryView || null;
        this.galleryView.galleryPageContainerView.numberOfItemsToShow = 1;
        this.galleryView.nextButtonView.setDelegate(this);
        this.galleryView.prevButtonView.setDelegate(this);
        this.galleryView.updatePagerItems();
    }

    // ************************** Event handlers **************************

    handleButtonClickEvent( event: ButtonClickEvent, provider ) {
        if( this.galleryView.galleryPageContainerView.animatingSubViewsCount ){
            // This guard prevents the pager view from misbehaving
            return;
        }

        // stop the view from auto-rotating its subviews
        this.galleryView.galleryPageContainerView.stopSubViewRotation();

        var pageIndex = null;
        if( event.button == this.galleryView.prevButtonView ) {
            pageIndex = this.galleryView.galleryPageContainerView.showPrev();
        }
        else if( event.button == this.galleryView.nextButtonView ) {
            pageIndex = this.galleryView.galleryPageContainerView.showNext();
        }

        if(this.galleryView.pagerView){
            this.galleryView.pagerView.selectIndex( pageIndex );
        }
    }
}
